export default __webpack_public_path__ + "static/media/Carousel1.80be9174.jpg";